module.exports = __webpack_public_path__ + "resources/img/check-on.230351ca.png";